import logo_amazon from './svg/logo_amazon.svg';
import logo_amazon_prime from './svg/logo_amazon_prime.svg';
import logo_amex from './svg/logo_amex.svg';
import logo_apple_pay from './svg/logo_apple_pay.svg';
import logo_apple_pay_white from './svg/logo_apple_pay_white.svg';
import logo_axepta from './svg/logo_axepta.svg';
import logo_axepta_white from './svg/logo_axepta_white.svg';
import logo_bcc_milano from './svg/logo_bcc_milano.svg';
import logo_beneficy from './svg/logo_beneficy.svg';
import logo_bike_channel from './svg/logo_bike_channel.svg';
import logo_booking from './svg/logo_booking.svg';
import logo_busforfun from './svg/logo_busforfun.svg';
import logo_corriere_della_sera from './svg/logo_corriere_della_sera.svg';
import logo_corriere_innovazione from './svg/logo_corriere_innovazione.svg';
import logo_destinationtech from './svg/logo_destinationtech.svg';
import logo_dovesciare from './svg/logo_dovesciare.svg';
import logo_easy_welfare from './svg/logo_easy_welfare.svg';
import logo_easyskipass from './svg/logo_easyskipass.svg';
import logo_edenred from './svg/logo_edenred.svg';
import logo_epipoli from './svg/logo_epipoli.svg';
import logo_esselunga from './svg/logo_esselunga.svg';
import logo_fnm from './svg/logo_fnm.svg';
import logo_frecciarossa from './svg/logo_frecciarossa.svg';
import logo_gazzetta from './svg/logo_gazzetta.svg';
import logo_google_pay from './svg/logo_google_pay.svg';
import logo_google_pay_white from './svg/logo_google_pay_white.svg';
import logo_gq from './svg/logo_gq.svg';
import logo_grazia from './svg/logo_grazia.svg';
import logo_guidaviaggi from './svg/logo_guidaviaggi.svg';
import logo_hipmiller from './svg/logo_hipmiller.svg';
import logo_il_giornale from './svg/logo_il_giornale.svg';
import logo_jointly from './svg/logo_jointly.svg';
import logo_la_repubblica from './svg/logo_la_repubblica.svg';
import logo_mastercard from './svg/logo_mastercard.svg';
import logo_mediaworld from './svg/logo_mediaworld.svg';
import logo_mister_gadget from './svg/logo_mister_gadget.svg';
import logo_offline from './svg/logo_offline.svg';
import logo_panorama from './svg/logo_panorama.svg';
import logo_paypal from './svg/logo_paypal.svg';
import logo_paypal_white from './svg/logo_paypal_white.svg';
import logo_radio_24 from './svg/logo_radio_24.svg';
import logo_satispay from './svg/logo_satispay.svg';
import logo_satispay_shopping_vouchers from './svg/logo_satispay_shopping_vouchers.svg';
import logo_satispay_white from './svg/logo_satispay_white.svg';
import logo_scalapay from './svg/logo_scalapay.svg';
import logo_scalapay_white from './svg/logo_scalapay_white.svg';
import logo_sciare_magazine from './svg/logo_sciare_magazine.svg';
import logo_sciaremagazine from './svg/logo_sciaremagazine.svg';
import logo_sepa_debit from './svg/logo_sepa_debit.svg';
import logo_sky_tg_24 from './svg/logo_sky_tg_24.svg';
import logo_sky_uno from './svg/logo_sky_uno.svg';
import logo_snowit_simple from './svg/logo_snowit_simple.svg';
import logo_snowit_tantosvago from './svg/logo_snowit_tantosvago.svg';
import logo_sportweek from './svg/logo_sportweek.svg';
import logo_startup_info from './svg/logo_startup_info.svg';
import logo_tantosvago from './svg/logo_tantosvago.svg';
import logo_train_fallback from './svg/logo_train_fallback.svg';
import logo_train_frecciabianca from './svg/logo_train_frecciabianca.svg';
import logo_train_frecciarossa from './svg/logo_train_frecciarossa.svg';
import logo_train_frecciarossa_1000 from './svg/logo_train_frecciarossa_1000.svg';
import logo_train_intercity from './svg/logo_train_intercity.svg';
import logo_train_intercity_notte from './svg/logo_train_intercity_notte.svg';
import logo_train_regionale from './svg/logo_train_regionale.svg';
import logo_train_regionale_veloce from './svg/logo_train_regionale_veloce.svg';
import logo_travelnostop from './svg/logo_travelnostop.svg';
import logo_trenitalia from './svg/logo_trenitalia.svg';
import logo_trenord from './svg/logo_trenord.svg';
import logo_trenord_gite_in_treno from './svg/logo_trenord_gite_in_treno.svg';
import logo_visa from './svg/logo_visa.svg';
import logo_welfare from './svg/logo_welfare.svg';
import logo_whatsapp from './svg/logo_whatsapp.svg';

const svgs = {
  logo_amazon,
  logo_amazon_prime,
  logo_amex,
  logo_apple_pay,
  logo_apple_pay_white,
  logo_axepta,
  logo_axepta_white,
  logo_bcc_milano,
  logo_beneficy,
  logo_bike_channel,
  logo_booking,
  logo_busforfun,
  logo_corriere_della_sera,
  logo_corriere_innovazione,
  logo_destinationtech,
  logo_dovesciare,
  logo_easy_welfare,
  logo_easyskipass,
  logo_edenred,
  logo_epipoli,
  logo_esselunga,
  logo_fnm,
  logo_frecciarossa,
  logo_gazzetta,
  logo_google_pay,
  logo_google_pay_white,
  logo_gq,
  logo_grazia,
  logo_guidaviaggi,
  logo_hipmiller,
  logo_il_giornale,
  logo_jointly,
  logo_la_repubblica,
  logo_mastercard,
  logo_mediaworld,
  logo_mister_gadget,
  logo_offline,
  logo_panorama,
  logo_paypal,
  logo_paypal_white,
  logo_radio_24,
  logo_satispay,
  logo_satispay_shopping_vouchers,
  logo_satispay_white,
  logo_scalapay,
  logo_scalapay_white,
  logo_sciare_magazine,
  logo_sciaremagazine,
  logo_sepa_debit,
  logo_sky_tg_24,
  logo_sky_uno,
  logo_snowit_simple,
  logo_snowit_tantosvago,
  logo_sportweek,
  logo_startup_info,
  logo_tantosvago,
  logo_train_fallback,
  logo_train_frecciabianca,
  logo_train_frecciarossa,
  logo_train_frecciarossa_1000,
  logo_train_intercity,
  logo_train_intercity_notte,
  logo_train_regionale,
  logo_train_regionale_veloce,
  logo_travelnostop,
  logo_trenitalia,
  logo_trenord,
  logo_trenord_gite_in_treno,
  logo_visa,
  logo_welfare,
  logo_whatsapp,
};

export type SvgLogosOthersList = keyof typeof svgs;
export default svgs;
